import util from "./_util";

const { request } = util;
export default {
  //心愿方向
  queryWishSort() {
    return request.get("/wish/get_region_category");
  },
  //发布心愿
  publishWish(data) {
    return request.post("/wish/add", data);
  },
  //查询当前用户发布的心愿列表
  queryCurWishList() {
    return request.get("/wish/pager_user_list");
  },
  //删除审核不通过的心愿
  deleteWish(data) {
    return request.post("/wish/delete", data);
  },
  //分页查询心愿主页的心愿数据
  queryWishList(params) {
    // params["uid"] = uid;
    return request.get("/wish/pager_for_index", {
      params,
    });
  },
  //心愿点赞
  thumbWish(data) {
    return request.post("/wish/prize", data);
  },
  // 收藏和取消收藏
  collectWish(data) {
    return request.post("/wish/collect", data);
  },
  //查询当前用户收藏的心愿列表
  queryCurCollectWish() {
    return request.get("/wish/pager_user_list");
  },
  //查询首页统计数字
  queryWishStatic() {
    return request.get("/wish/get_wish_statistics");
  },
  //查询某个心愿详情
  queryWishDetail(params) {
    return request.get("/wish/get_info?id=" + params);
  },
  //查询用户是否有待评价的心愿
  queryWaitCommentWish() {
    return request.get("/wish/get_wait_comment_wish");
  },
  // 用户发布心愿评价
  publishWishComment(data) {
    return request.post("/wish/comment", data);
  },
  //查询排行榜
  queryWishRank(params) {
    return request.get("/wish/get_rank?type=" + params);
  },
};
